import { render, staticRenderFns } from "./LoyaltyPointHistoryMobilePreview.vue?vue&type=template&id=228419c6&scoped=true&"
import script from "./LoyaltyPointHistoryMobilePreview.vue?vue&type=script&lang=js&"
export * from "./LoyaltyPointHistoryMobilePreview.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyPointHistoryMobilePreview.vue?vue&type=style&index=0&id=228419c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228419c6",
  null
  
)

export default component.exports